import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// components
import User from "./User";
import MarketingMessageModal from "../components/MarketingMessageModal";

// styles
import { convertPxToRem } from "frontend/components/helpers";
const RightBlockStyled = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-end;
    gap: ${convertPxToRem(40)};
`;

// component
export const RightBlock = ({
    className,
    isDisabled = false,
    onFocusScroll,
    showMarketingMessageModal = false
}) => {
    return (
        <RightBlockStyled className={className}>
            {showMarketingMessageModal && <MarketingMessageModal />}
            <User isDisabled={isDisabled} onFocusScroll={onFocusScroll} />
        </RightBlockStyled>
    );
};

export default RightBlock;

// prop-types
RightBlock.propTypes = {
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    onFocusScroll: PropTypes.func,
    showMarketingMessageModal: PropTypes.bool
};
